module.exports = " <div class=lock-page v-show=show> <h4 :style=hSty><i class=\"glyphicon glyphicon-repeat\"></i> {{content}}……</h4> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/common/lockPage.vue
// module id = 25
// module chunks = 1 3 4